import {
  WgtPage,

  WgtNewSlider,
  WgtHotZone,
  WgtHoriZontal,
  WgtblokScroll,
  WgtFilm,
  WgtAbtest,

  WgtStickyLift,
  WgtTabsCut,
  WgtOldGoods,
  WgtOldEvaluate,
  WgtWallPaper,

  WgtAroundStoreOne,
  WgtFunctionBlock,
  WgtProductShelves,
  WgtLift,

  WgtContentPart,
  WgtClassify,
  WgtCustomWgt,
  WgtImageText,
  WgtArticle,
  WgtMemberInfo,
  WgtSuspension,
  WgtUserContainer,
  WgtOfficialAccount,
  WgtNewMemberInfo,
  wgtDevices,
  WgtMemberTask
} from "../wgts/index";

export const initiWidgets = [
  // {
  //   name: "functionBlock",
  //   params: {
  //     name: "functionBlock",
  //     base: {
  //       wgtName: "功能区",
  //       wgtDesc: "",
  //       content: "category.png",
  //       type: "category",
  //     },
  //   },
  // },
];

export const widgets = {
  WgtPage,

  WgtNewSlider,
  WgtHotZone,
  WgtHoriZontal,
  WgtblokScroll,
  WgtFilm,
  WgtAbtest,

  WgtStickyLift,
  WgtTabsCut,
  WgtOldGoods,
  WgtOldEvaluate,
  WgtWallPaper,

  WgtAroundStoreOne,
  WgtFunctionBlock,
  WgtProductShelves,
  WgtLift,

  WgtContentPart,
  WgtClassify,
  WgtCustomWgt,
  WgtImageText,
  WgtArticle,
  WgtMemberInfo,
  WgtSuspension,
  WgtUserContainer,
  WgtOfficialAccount,
  WgtNewMemberInfo,
  wgtDevices,
  WgtMemberTask
};

export default {
  widgets,
  initiWidgets,
};
